import React from 'react';
import { useGetTenantCommoditySettingsQuery } from '../redux/api/tenant/tenantApi';
import { CommodityConfig, MeasurementSystem } from '../providers/User/User.model';
import useFeatureFlags from '../providers/FeatureFlags/FeatureFlags.provider';

export interface UseCommoditySettingsResult {
  commoditySettings: CommodityConfig | null;
  measurementSystem: MeasurementSystem;
  isDimensionsEnabled: boolean;
  isUnitEnabled: boolean;
  isPermitRequirementEnabled: boolean;
  isCommodityIdEnabled: boolean;
  isMakeEnabled: boolean;
  isModelEnabled: boolean;
  loading: boolean;
}

export const useCommoditySettings = (): UseCommoditySettingsResult => {
  const { enableCommoditiesDatabase } = useFeatureFlags();
  const skip = !enableCommoditiesDatabase;
  const { data: commoditySettings, isLoading } = useGetTenantCommoditySettingsQuery(null, { skip });

  const isDimensionsEnabled = React.useMemo(() => {
    return commoditySettings?.config?.dimensions ?? false;
  }, [commoditySettings]);

  const isUnitEnabled = React.useMemo(() => {
    return commoditySettings?.config?.unit ?? false;
  }, [commoditySettings]);

  const isPermitRequirementEnabled = React.useMemo(() => {
    return commoditySettings?.config?.permit_requirement ?? false;
  }, [commoditySettings]);

  const isCommodityIdEnabled = React.useMemo(() => {
    return commoditySettings?.config?.commodity_id ?? false;
  }, [commoditySettings]);

  const isMakeEnabled = React.useMemo(() => {
    return commoditySettings?.config?.make ?? false;
  }, [commoditySettings]);

  const isModelEnabled = React.useMemo(() => {
    return commoditySettings?.config?.model ?? false;
  }, [commoditySettings]);

  if (!enableCommoditiesDatabase) {
    return {
      commoditySettings: null,
      measurementSystem: MeasurementSystem.IMPERIAL,
      isDimensionsEnabled: false,
      isUnitEnabled: false,
      isPermitRequirementEnabled: false,
      isCommodityIdEnabled: false,
      isMakeEnabled: false,
      isModelEnabled: false,
      loading: false,
    };
  }

  return {
    commoditySettings: commoditySettings?.config ?? null,
    measurementSystem: commoditySettings?.config?.measurement_system ?? MeasurementSystem.IMPERIAL,
    isDimensionsEnabled,
    isUnitEnabled,
    isPermitRequirementEnabled,
    isCommodityIdEnabled,
    isMakeEnabled,
    isModelEnabled,
    loading: isLoading,
  };
}; 